import EarnedCertificate from "../../../../ReusableComponent/EarnedCertificate";

const EarnedCertificatesSection = () => {
  const certificates = [
    {
      title: "JavaScript Expert",
      subject: "JavaScript",
      level: "Expert",
      issueDate: "2024-01-15",
      score: 95,
      verificationId: "JS-EXP-2024-001",
    },
    {
      title: "React Developer",
      subject: "React",
      level: "Advanced",
      issueDate: "2024-01-10",
      score: 88,
      verificationId: "REACT-ADV-2024-002",
    },
    {
      title: "Database Administrator",
      subject: "SQL",
      level: "Expert",
      issueDate: "2024-01-05",
      score: 92,
      verificationId: "SQL-EXP-2024-003",
    },
  ];

  return (
    <section className="row mx-0 py-5 d-flex justify-content-center align-items-center earned-certificates">
      <div className="col-md-11 col-12">
        <div className="row mx-0 d-flex justify-content-center align-items-center">
          <div className="col-12 text-center mb-5">
            <h3 className="text-center fw-bold text-light mb-4">
              Your Earned Certificates
            </h3>
          </div>
          <div className="row mx-0">
            {certificates.map((cert, index) => (
              <EarnedCertificate
                key={index}
                title={cert.title}
                subject={cert.subject}
                level={cert.level}
                issueDate={cert.issueDate}
                score={cert.score}
                verificationId={cert.verificationId}
                onDownload={() => alert(`Downloading ${cert.title}`)}
                onVerify={() => alert(`Verifying ${cert.title}`)}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default EarnedCertificatesSection;
